import { render, staticRenderFns } from "./upFile.vue?vue&type=template&id=5883bc00&"
import script from "./upFile.vue?vue&type=script&lang=js&"
export * from "./upFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports